/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Chat_Model_Settings_BlurbInputs */



/**
* | output |
* | --- |
* | "Choose the AI model for this chat and how deeply it reasons. Stronger models and higher reasoning give more thorough answers but take longer; the free oneAI ..." |
*
* @param {Uno_Edu_Chat_Model_Settings_BlurbInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_chat_model_settings_blurb = /** @type {((inputs?: Uno_Edu_Chat_Model_Settings_BlurbInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Chat_Model_Settings_BlurbInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie das KI-Modell für diesen Chat und wie tief es nachdenkt. Stärkere Modelle und höheres Reasoning liefern gründlichere Antworten, dauern aber länger; das kostenlose Modell oneAI Standard ist immer verfügbar.")
	return /** @type {LocalizedString} */ ("Choose the AI model for this chat and how deeply it reasons. Stronger models and higher reasoning give more thorough answers but take longer; the free oneAI Standard model is always available.")
});